import { render } from "./TableDefault.vue?vue&type=template&id=98dfe7e0&scoped=true"
import script from "./TableDefault.vue?vue&type=script&lang=js"
export * from "./TableDefault.vue?vue&type=script&lang=js"

import "./TableDefault.vue?vue&type=style&index=0&id=98dfe7e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98dfe7e0"]])

export default __exports__